import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const root = (theme: Theme) => css`
  &:not(:last-of-type) {
    margin-bottom: ${size[24]};
  }

  ${breakpoint.up('sm')} {
    padding: ${size[32]} ${size[48]};
    border-radius: ${theme.borderRadius.sm};
  }

  ${breakpoint.up('md')} {
    padding: ${size[64]} ${size[80]};
  }

  ${breakpoint.down('xs')} {
    padding: 0;
    background: transparent;
    box-shadow: none;
  }
`
